import * as React from "react";
import { forwardRef, Fragment, useState } from "react";
import { ProductResult } from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { CatalogItemBox } from "./catalog_item_box";
import ComparatorModal from "./comparator_message";

export type ProductsProps = {
  products: ProductResult[];
  membersOnlyProducts: Record<number, number>;
};

export const CatalogItemBoxList = React.memo(
  forwardRef<HTMLUListElement, ProductsProps>(
    ({ products, membersOnlyProducts }, ref): JSX.Element => {
      const [messageIsShown, setMessageIsShown] = useState(false);

      const hideMessage = () => {
        setMessageIsShown(false);
      };

      const refreshMessage = () => {
        setMessageIsShown(false);
        setTimeout(() => {
          setMessageIsShown(true);
        }, 150);
      };

      const isMemberOnly = (product: any) => {
        const productId = parseInt(product.catalogId.split("_")[1]);

        return membersOnlyProducts.hasOwnProperty(productId);
      };

      const publicAndMemberProducts = () => {
        const membersProducts = (products ?? []).filter((product) =>
          isMemberOnly(product)
        );
        const publicProducts = (products ?? []).filter(
          (product) => !isMemberOnly(product)
        );

        if (membersProducts.length === 0) return [...publicProducts];

        const result = [];
        const total = publicProducts.length + membersProducts.length;
        const step = Math.floor(total / membersProducts.length);

        let publicIndex = 0,
          membersIndex = 0;

        for (let i = 0; i < total; i++) {
          if ((i + 1) % step === 0 && membersIndex < membersProducts.length) {
            result.push(membersProducts[membersIndex++]);
          } else if (publicIndex < publicProducts.length) {
            result.push(publicProducts[publicIndex++]);
          }
        }

        return result;
      };

      return (
        <Fragment>
          <ul className="cleaner product-list-lower" ref={ref}>
            {publicAndMemberProducts().map((product) => (
              <CatalogItemBox
                product={product}
                key={product.catalogId}
                onRefreshMessage={refreshMessage}
                membersOnly={isMemberOnly(product)}
              />
            ))}
          </ul>
          {messageIsShown && <ComparatorModal onClose={hideMessage} />}
        </Fragment>
      );
    }
  )
);
